import React, { FC, useEffect, useRef, useState } from 'react'
import { Modal } from 'antd';
import { globalPrompt } from '@/components/message';
import { homeService } from '@/views/home/homeService';
import { FormItemTypeEnum, ISelectOption, IYhForm, IYhFormRef } from '@/components/YhFormBox/Types';
import { YhForm } from '@/components/YhFormBox';
import { useGlobalModel } from '@/model/globalModel';
import { RouterParamType } from '@/model/navModel';
import { usePurchaseEnquiryDetailsModel } from "./purchaseEnquiryDetailsModel";
import { purchaseEnquiryService } from '../../purchaseEnquiryService';
import { supplierMapModel } from '@/utils/supplierMap';
const ChangeSupplier: FC<RouterParamType> = ({ id, mode }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { changeSupplierVisible, detailDataSource, setChangeSupplierVisible, getDetailEditOne, returnList, detailEditForm, selectSupplier, setSelectSupplier } = usePurchaseEnquiryDetailsModel();
  const { user: { roles }, setLoadingInfo, supplieAllList } = useGlobalModel();
  useEffect(() => {
    if (!changeSupplierVisible) {
      formRef.current?.resetFields();
    }
  }, [changeSupplierVisible])
  const { supplierMap } = supplierMapModel();
  const handleCancel = () => {
    console.log('Clicked cancel button');
    setChangeSupplierVisible(false);
  };
  const formRef = useRef<IYhFormRef>();
  const newSupplierCodeChange = (value: string, option: ISelectOption) => {
    const supplier = supplierMap.filter(e => value.indexOf(e.code) > -1)
    formRef.current?.setFieldsValue({
      ...selectSupplier,
      newSupplierCode: value,
      newSupplierName: option.label,
      newPrice: selectSupplier[supplier[0].idx + 'OfferPrice'] ?? 0,
      newDeliveryTime: selectSupplier[supplier[0].idx + 'DeliveryTime'] ?? '',
      newnote: '',
    });
    setSelectSupplier({ ...selectSupplier, type: selectSupplier[supplier[0].idx + 'OfferPrice'] ? 'noEdit' : '' })
  }
  const formConfig: IYhForm = {
    formRef,
    labelCol: { span: 6 },
    formValues: {
      ...selectSupplier,
    },
    items: [
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "商品编码",
        fieldName: "materialCode",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "商品名称",
        fieldName: "materialName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "系统优选供应商",
        fieldName: "supplierName",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "供应商送货价",
        fieldName: "price",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "送货时间",
        fieldName: "deliveryTime",
        disable: true,
        span: 24,
      },
      {
        type: FormItemTypeEnum.Select,
        fieldLabel: "变更供应商",
        fieldName: "newSupplierCode",
        options: supplieAllList.filter((list: any) => list.typeCode == returnList[detailEditForm.approveTypeCode]).map((item: any) => {
          if (item.code == selectSupplier.supplierCode) {
            return { value: item.code, label: item.name, disabled: true }
          } else {
            return { value: item.code, label: item.name, }
          }
        }),
        showSearch: false,
        span: 24,
        onSelectChange: newSupplierCodeChange,
        rules: [{ required: true, message: "请选择变更供应商" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "变更后送货价",
        fieldName: "newPrice",
        span: 24,
        disable: selectSupplier.type == 'noEdit' ? true : false,
        rules: [{ required: true, message: "请输入变更后送货价" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "变更后送货时间",
        fieldName: "newDeliveryTime",
        span: 24,
        disable: selectSupplier.type == 'noEdit' ? true : false,
        rules: [{ required: true, message: "请输入变更后送货时间" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "变更备注",
        fieldName: "newnote",
        span: 24,
        rules: [{ required: true, message: "请输入变更备注" }],
      },
      {
        type: FormItemTypeEnum.Input,
        fieldLabel: "变更供应商",
        fieldName: "newSupplierName",
        span: 24,
        hidden: true,
      },
    ]
  };

  const onOk = async () => {
    try {
      setConfirmLoading(true);
      const formData = await formRef.current?.validateFields();
      setConfirmLoading(false);
      if (formData) {
        const params: any = {
          id: selectSupplier.id,
          newSupplierCode: formData.newSupplierCode,
          newSupplierName: supplieAllList.find((item: any) => item.code == formData.newSupplierCode)?.name,
          newPrice: formData.newPrice,
          note: formData.newnote,
          newDeliveryTime: formData.newDeliveryTime,
        }
        const insertRet = await purchaseEnquiryService.changeSupplier(params);
        if (insertRet.success) {
          await globalPrompt("message", { type: "success", text: '修改成功!' });
          setChangeSupplierVisible(false);
          getDetailEditOne(id as string, mode)
        } else {
          await globalPrompt("message", { type: "error", text: "修改失败!" + insertRet.retMsg });
        }

      }
    } catch (e) {
      console.log("失败!");
    }
  }

  return (
    <Modal
      title="供应商变更"
      visible={changeSupplierVisible}
      onOk={onOk}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
    >
      <YhForm  {...formConfig} />
    </Modal>
  );
};

export default ChangeSupplier;